import SkillLevelCodebookContainer from '@src/components/codebook/SkillLevelCodebookContainer';
import React from 'react';

const AdminSkillLevelCodebookPage = () => <SkillLevelCodebookContainer/>;

export default AdminSkillLevelCodebookPage;
